import React from 'react';
import "./BarftMediaDialog.css"
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import classNames from 'classnames';
import { BsyUtils } from '../../../utils/Utils';

export default class BarftMediaDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeType: 'img',
            carouselMapFlies: [],
            linkType: true
        };
        this.linkTitle = ""
        this.inputRef = React.createRef();
    }
    componentDidMount() {
    }
    changeEditImg = (event) => {
        let _this = this;
        const selectedFiles = Array.from(event.target.files);
        const maxSize = window.FX.STATIC.VIP_PACK.single_file; // 5MB
        let errorFileName = false
        let successFile = [];


        selectedFiles.forEach((item, key) => {
            if (item.size >= maxSize) {
                errorFileName = true
            }
        });
        if (errorFileName) {
            //最多5M个
            tipAlert({
                msg: errorFileName + React.language("image.upload.size.rules.one",{count: window.FX.STATIC.VIP_PACK.single_file/1024/1024}),
                type: "warning",
            });
            return;
        }
        let list = this.state.carouselMapFlies;
        this.setState({
            carouselMapFlies: list.concat(selectedFiles),
        });
        selectedFiles.forEach((item, key) => {
            const formData = new FormData();
            formData.append("file", item);
            formData.append(
                "x:uploader",
                window.FX.STATIC.user ? window.FX.STATIC.user._id : ""
            );
            React.axios("/dashboard/upload_workbenches_img", formData)
                .then((res) => {
                    successFile = successFile.concat([res.data.file]);
                    if (selectedFiles.length === successFile.length) {
                        uploadSucess();
                    }
                })
                .catch((err) => {
                    tipAlert({
                        type: "warning",
                        msg: err,
                    });
                })
                .finally(() => { });
        });
        function uploadSucess() {
            let list = _this.state.carouselMapFlies;
            list = list.concat(successFile);
            list = list.filter((item) => {
                return item.qnKey;
            });
            _this.setState({
                carouselMapFlies: list,
            });
        }
    }
    linkTitleEdit = (event) => {
        this.linkTitle = event.target.value
        let Ok = checkURL(this.linkTitle)
        this.setState({
            linkType: Ok
        })
        function checkURL(URL) {
            var str = URL;
            //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
            //下面的代码中应用了转义字符"\"输出一个字符"/"
            var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
            var objExp = new RegExp(Expression);
            if (objExp.test(str) == true) {
                return true;
            } else {
                return false;
            }
        }
    }
    blurLinkTitleEdit = () => {
        let Ok = checkURL(this.linkTitle)
        console.log(Ok)
        function checkURL(URL) {
            var str = URL;
            //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
            //下面的代码中应用了转义字符"\"输出一个字符"/"
            var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
            var objExp = new RegExp(Expression);
            if (objExp.test(str) == true) {
                return true;
            } else {
                return false;
            }
        }
    }
    changeType = (type) => {
        this.setState({
            activeType: type
        })
    }
    deleteImg = (key) => {
        let carouselMapFlies = this.state.carouselMapFlies
        carouselMapFlies.splice(key, 1)
        this.setState({
            carouselMapFlies: carouselMapFlies,
        });
    }
    render() {
        return <div className='t-braft-utils-media-dialog'>
            <div className='left'>
                <div onClick={() => { this.changeType('img') }} className={classNames(this.state.activeType === 'img' ? "active" : "")}><i className='icon-image' ></i><span>上传图片</span></div>
                <div onClick={() => { this.changeType('link') }} className={classNames(this.state.activeType === 'link' ? "active" : "")}><i className='icon-link' ></i><span>图片URL</span></div>
            </div>
            <div className='right'>
                {this.state.activeType === 'img' && <div className='upload-img'>
                    <div className='up-tip'>
                        <div className='title'>上传图片</div>
                        <div className='tip'>注：{React.language('image.upload.rules.one', {count: window.FX.STATIC.VIP_PACK.single_file/1024/1024})}</div>
                    </div>
                    <div className='upload-btn'>
                        <i className='icon-bsy-reportmenu-7 upload-icon'></i>
                        <span>点击或拖拽图片上传</span>
                        <form
                            className="upload-form"
                            action="/file/upload_des_img"
                            method="post"
                        >
                            <input
                                type="file"
                                name="file"
                                multiple="multiple"
                                onChange={this.changeEditImg}

                                accept=".jpg,.png,.jpeg,.gif"
                            />
                        </form>
                    </div>
                    <ul>
                        {
                            this.state.carouselMapFlies.map((item, key) => {
                                const url = BsyUtils.getfiledownloadURL(item, {});
                                return <li key={key}>
                                    <div className='img-box'>
                                        <img src={url} alt='' />
                                    </div>
                                    {item.qnKey && <div className='info'>
                                        <div className='title'>{item.name}</div>
                                        <div className='sub'>{(item.size / 1024).toFixed(2)}kb</div>
                                    </div>}
                                    {item.qnKey && <div className='remove-btn' onClick={() => {
                                        this.deleteImg(key)
                                    }}>
                                        <i className='icon-bby-reportmenu-9'></i>
                                    </div>}

                                    {!item.qnKey && (
                                        <div className="loading">
                                            <div className="node"></div>
                                            <div className="node"></div>
                                            <div className="node"></div>
                                            <div className="node"></div>
                                            <div className="node"></div>
                                            <div className="node"></div>
                                            <div className="node"></div>
                                            <div className="node"></div>
                                        </div>
                                    )}
                                </li>
                            })
                        }

                    </ul>
                </div>}

                {
                    this.state.activeType === 'link' && <div className='upload-link'>
                        <div className='up-tip'>
                            <div className='title'>图片URL</div>
                            <div className='tip'>注：输入图片URL即可插入图片</div>
                        </div>
                        <div className='input-box'>
                            <input placeholder="https://" ref={this.inputRef}
                                onInput={(event) => {
                                    this.linkTitleEdit(event);
                                }}
                                className={classNames(this.state.linkType ? "" : 'error')}
                                onBlur={() => { this.blurLinkTitleEdit() }}
                            ></input>
                        </div>
               
                    </div>
                }
            </div>
        </div>;
    }
}